import clickElement from './click-element';
import event, {EVENTS} from '../../lib/event';
import Audio from "../../lib/audio";
import Cartoon from '../avatar-action';
import {BATCH_TIPS_MODE} from '../../lib/constant';
import {setKeybord} from '../../reducers/teach';

/**
 * 提示点击小绿旗运行游戏
 * @param tips
 * @param keyboard 设置键盘类型，undefined或者0表示没有虚拟键盘，
 * @returns {Promise<unknown>}
 */
export default function run({tips, keyboard}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    //document.querySelector('img[alt="放大舞台"]').click();
    //event.once(EVENTS.GAME_FINISH, ()=>{document.querySelector('img[alt="缩小舞台"').click();})

    if (!tips) tips = '点击小绿旗运行程序';
    if (mode) {
        window.stepsRuntime.insertTips(_index, tips, true);
        if (mode === BATCH_TIPS_MODE) {
            return new Promise(resolve => {
                resolve();
            })
        }
    }
    if (keyboard) {
        window.store.dispatch(setKeybord(keyboard));
    }
    return new Promise((resolve, reject)=>{
        const waitForBigStage = ()=>{
            /*
            if (document.querySelector(".gui_stage-and-target-wrapper_69KBf").clientWidth < 400) { //等待舞台变大
                setTimeout(waitForBigStage, 100);
            }else {
                */
                clickElement({element: () => document.querySelector('img[class^="green-flag_green-flag"]'), tips}).then(resolve, reject);
                //}
        }
        waitForBigStage();
    })
}
